export class Constant {
    public static get PolicyYear(): number {
        var policyYear: number = new Date().getFullYear() - 1;
        const month: number = new Date().getMonth() + 1;
        const date: number = new Date().getDate();
        let monthCheck: number;
        let dateCheck: number;
        if ((month >= 8 && date >= 28) && (month < 7 && date < 1)) {
            dateCheck = 28;
            monthCheck = 8;
        } else {
            dateCheck = 1;
            monthCheck = 7;
        }
        if (month >= monthCheck && date >= dateCheck) {
            policyYear++;
        }
        return policyYear;
    }
}